import { render, staticRenderFns } from "./Notification.vue?vue&type=template&id=6c3a3344&scoped=true&lang=pug&"
var script = {}
import style0 from "./Notification.vue?vue&type=style&index=0&id=6c3a3344&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c3a3344",
  null
  
)

export default component.exports